import { Component, Input, OnInit } from '@angular/core';
import {
  RolloverOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover.options';
import {
  RolloverResult,
} from '../../../../../../../../../../../server/dist/angular/server/src/engine/calculations/rollover/results/rollover.result';
import {
  RolloverPropertyTransferredResult,
} from '../../../../../../../../../../../server/dist/angular/server/src/engine/calculations/rollover/results/rollover-property-transferred.result';
import {
  RolloverPropertyTransferredOptions,
} from '../../../../../../../../../../../common/src/options/calculations/rollover/rollover-property-transferred.options';

@Component({
  selector: 'app-rollover-recaptured-depreciation-result',
  templateUrl: './rollover-recaptured-depreciation-result.component.html',
  styleUrls: ['./rollover-recaptured-depreciation-result.component.scss'],
  standalone: false,
})
export class RolloverRecapturedDepreciationResultComponent implements OnInit {

  @Input()
  options: RolloverOptions;
  @Input()
  results: RolloverResult;
  @Input()
  propertyTransferredOptions: RolloverPropertyTransferredOptions;
  @Input()
  propertyTransferredResults: RolloverPropertyTransferredResult;

  isSectionRecapturedDepreciationCollapsed: boolean = false;

  @Input()
  selectedBadge: string;

  ngOnInit() {
  }
}
